import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import customFetch from "../utils/customFetch";

export type ChatMessage = {
  role: string;
  content: string;
};

export type ChatWorkflowRequest = {
  prompt: string;
  history: ChatMessage[];
};

export const useChatWorkflow = () => {
  return useMutation<string, ErrorEvent, ChatWorkflowRequest>({
    mutationFn: ({ prompt, history }) => {
      return customFetch(`/v1/generate-workflow`, {
        method: 'POST',
        body: JSON.stringify({ prompt, history })
      })
        .then(async(res) => {
          const data = await res.text();
          return res.ok
            ? data
            : Promise.reject(new Error('Failed to generate chat response'))
        })
        .catch((err) => {
          toast.error(err.message);
          throw err;
        });
    }
  });
}; 